import { transport } from 'config/transport';

export function callApiSaveThuNoiTru(congDoanId, month, year, body) {
    return transport.post(`/noitru/${congDoanId}/thuchi/thunoitru`, body, { params: { month, year } });
}
